import { CampaignCallout } from '@vp/campaign-callouts'
import { FlexBox, Callout, Responsive, StyleSpace, Box } from '@vp/swan'
import { hasValidTagType } from '../types/Callout'
import { CalloutType, ProductCallout } from './AutoGenerate/types/AutomatedExperience'

interface CalloutWrapperProps {
  callout?: ProductCallout | ProductCallout[]
  enableCampaignCallouts?: boolean
  mpvId?: string
  styleConfig?: StyleConfig
}

interface StyleConfig {
  marginTop?: Responsive<StyleSpace>
  marginBottom?: Responsive<StyleSpace>
  marginLeft?: Responsive<StyleSpace>
  marginRight?: Responsive<StyleSpace>
}

export const CalloutWrapper = ({
  callout,
  enableCampaignCallouts,
  mpvId,
  styleConfig
}: CalloutWrapperProps) => {
  const isCalloutArray = Array.isArray(callout)

  const { marginTop = 0, marginBottom = 0, marginLeft = 0, marginRight = 0 } = styleConfig ?? {}

  return (
    <FlexBox flexDirection="column" gap="2">
      {isCalloutArray ? (
        (callout as ProductCallout[]).map((item, idx) => {
          if (item.type === CalloutType.CAMPAIGN && mpvId && enableCampaignCallouts) {
            return (
              <Box mt={marginTop} mb={marginBottom} ml={marginLeft} mr={marginRight} key={mpvId}>
                <CampaignCallout product={mpvId} key={idx} />
              </Box>
            )
          }
          if (
            (item.type === CalloutType.OUT_OF_STOCK ||
              (item.type === CalloutType.TAG && hasValidTagType(item))) &&
            item.value &&
            item.value !== '' &&
            item.skin &&
            (item.variant || item.emphasis)
          ) {
            return (
              <Callout
                skin={item.skin}
                variant={item.variant ?? null}
                emphasis={item.emphasis ?? null}
                style={{ width: 'fit-content' }}
                key={idx}
                data-testid="callout"
                mt={marginTop}
                mb={marginBottom}
                ml={marginLeft}
                mr={marginRight}
              >
                {item.value}
              </Callout>
            )
          }
          return null
        })
      ) : (
        <>
          {callout?.value &&
            callout?.value !== '' &&
            callout?.skin &&
            (callout?.variant || callout?.emphasis) &&
            hasValidTagType(callout) && (
              <Callout
                skin={callout.skin}
                variant={callout.variant ?? null}
                emphasis={callout.emphasis ?? null}
                style={{ width: 'fit-content' }}
                data-testid="callout"
                mt={marginTop}
                mb={marginBottom}
                ml={marginLeft}
                mr={marginRight}
              >
                {callout.value}
              </Callout>
            )}
          {enableCampaignCallouts && <CampaignCallout product={mpvId ?? ''} />}
        </>
      )}
    </FlexBox>
  )
}
